import { useCallback, useContext, useRef } from "react";
import { Box, TextInput } from "@mantine/core";
import { EditableInfoRowContext } from "./EditableInfoRowContext";
import type { PatientInfo, SaveRequisitionFields } from "./DocumentHeaderTypes";

interface PatientNameEditorProps {
  patient: PatientInfo;
  savePatient: SaveRequisitionFields;
}

export function PatientNameEditor({
  patient,
  savePatient,
}: PatientNameEditorProps) {
  const setOverride = useContext(EditableInfoRowContext);
  const names = useRef({
    lastName: patient.lastName,
    firstName: patient.firstName,
  });
  const updateDisplay = useCallback(() => {
    const separator = names.current.lastName && names.current.firstName;
    setOverride?.(
      `${names.current.lastName}${separator ? ", " : ""}${
        names.current.firstName
      }`
    );
  }, [setOverride]);
  const handleLastNameBlur = useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      names.current.lastName = event.target.value;
      updateDisplay();
      savePatient({ lastName: event.target.value });
    },
    [savePatient, updateDisplay]
  );
  const handleFirstNameBlur = useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      names.current.firstName = event.target.value;
      updateDisplay();
      savePatient({ firstName: event.target.value });
    },
    [savePatient, updateDisplay]
  );

  return (
    <Box style={{ display: "flex", gap: 4 }}>
      <TextInput
        size="xs"
        placeholder="Last name"
        defaultValue={patient.lastName}
        onBlur={handleLastNameBlur}
        style={{ flex: 1 }}
      />
      <TextInput
        size="xs"
        placeholder="First name"
        defaultValue={patient.firstName}
        onBlur={handleFirstNameBlur}
        style={{ flex: 1 }}
      />
    </Box>
  );
}
